<template>
  <!-- Detail page opened from Global Search (?from=search): back to the same results page, filters and per-page -->
  <!-- real <a href> to the saved search (open in new tab); a plain click keeps the history-back behaviour below -->
  <router-link v-if="show" v-slot="{ href }" :to="target" custom>
  <a :href="href"
    class="inline-flex items-center gap-2 mb-[30px] px-[14px] py-[6px] rounded-full border-0 font-roboto text-[14px] text-[#8479E1] no-underline bg-[#fff] shadow-[0_0_10px_0_#0000001A] hover:bg-[#F3F0FF] transition-colors"
    @click="onClick">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    Back to search results
  </a>
  </router-link>
</template>

<script>
import { isNewTabClick } from "@/helpers/newTabClick";

export default {
  computed: {
    // the results page to return to: ?back= from the search link (works in a new tab), else the one saved in this tab
    target() {
      const back = this.$route.query.back;
      if (typeof back === 'string' && back.startsWith('/global-search')) return back;
      return (this.$route.fullPath && this.savedPath()) || { name: 'globalSearch' };
    },
    show() {
      return this.$route.query.from === 'search' && this.$route.name !== 'globalSearch';
    },
  },
  // while this button shows, the card's round back button (DetailBackButton, below laptop) hides — one back button
  watch: {
    $route: { immediate: true, handler() { this.$nextTick(() => document.documentElement.classList.toggle("fxBackToSearch", this.show)); } },
  },
  beforeUnmount() {
    document.documentElement.classList.remove("fxBackToSearch");
  },
  methods: {
    savedPath() {
      try {
        return sessionStorage.getItem('search_return_path');
      } catch (e) {
        return null;
      }
    },
    onClick(e) {
      if (isNewTabClick(e)) return; // browser opens the results in a new tab
      e.preventDefault();
      this.goBack();
    },
    goBack() {
      const target = this.target;
      // straight from the results: browser back keeps the results page's scroll; otherwise open that results page
      if (typeof target === 'string' && window.history.state && window.history.state.back === target) {
        this.$router.back();
      } else {
        this.$router.push(target);
      }
    },
  },
};
</script>
